import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { ResponseMessage } from "../../common/model/ResponseMessage";
import { RouteAPI, api } from "../../common/service/apiService";
import { UserProfessionnelResponse } from "../model/Disponibilite";
import { UserStructureResponse } from "../../structures/model/StructureModel";

interface DisponibilitiesResponse {
    professionnels: UserProfessionnelResponse[];
    structures: UserStructureResponse[];
}

export const getDisponibilities = createAsyncThunk<
    DisponibilitiesResponse,
    {
        page: number;
        itemsPerPage: number;
        filters?: Record<string, any>;
        role?: "ROLE_STRUCTURE" | "ROLE_PROFESSIONNEL";
    } | null
>("search/getAll", async (params, { rejectWithValue }) => {
    try {
        const page = params?.page || 1;
        const itemsPerPage = params?.itemsPerPage || 20;
        const filters = params?.filters || {};
        const role = params?.role || "";

        let queryParams = `?enabled=true&page=${page}&itemsPerPage=${itemsPerPage}`;
        for (const [key, value] of Object.entries(filters)) {
            if (Array.isArray(value)) {
                value.forEach((val) => {
                    if (val === undefined || val === "") return;

                    queryParams += `&${encodeURIComponent(key)}[]=${val}`;
                });
                continue;
            }

            if (value === undefined && value === "") continue;
            queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(
                value
            )}`;
        }

        let professionnelResponse = { data: [] as UserProfessionnelResponse[] };
        let structureResponse = { data: [] as UserStructureResponse[] };

        if (role === "ROLE_STRUCTURE") {
            // Replace "profession[]" with "account.profession[]" as professional availabilities doesn't have a profession property
            // The profession is accessed through the professional's account
            queryParams = queryParams.replaceAll(
                "profession[]=",
                "account.profession[]="
            );

            structureResponse = await api(
                RouteAPI.DISPONIBILITE_PROFESSIONNELS + queryParams,
                "GET"
            );
        }

        if (role === "ROLE_PROFESSIONNEL") {
            professionnelResponse = await api(
                RouteAPI.DISPONIBILITE_STRUCTURE + queryParams,
                "GET"
            );
        }

        if (!role) {
            [professionnelResponse, structureResponse] = await Promise.all([
                api(RouteAPI.DISPONIBILITE_PROFESSIONNELS + queryParams, "GET"),
                api(RouteAPI.DISPONIBILITE_STRUCTURE + queryParams, "GET"),
            ]);
        }

        return {
            professionnels: professionnelResponse.data,
            structures: structureResponse.data,
        };
    } catch (error) {
        return rejectWithValue(error as AxiosError<ResponseMessage>);
    }
});

export const postSmart = createAsyncThunk<
    any,
    { id: string; role: "ROLE_PROFESSIONNEL" | "ROLE_STRUCTURE" | "structure" }
>("search/postSmart", async ({ id, role }, thunkAPI) => {
    try {
        const url =
            role === "ROLE_PROFESSIONNEL"
                ? RouteAPI.DISPONIBILITE_STRUCTURE + "/" + id + "/professionel"
                : RouteAPI.DISPONIBILITE_PROFESSIONNELS +
                  "/" +
                  id +
                  "/structure";
        const response = await api(url, "PATCH");
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error as AxiosError<ResponseMessage>);
    }
});

// export const getAllDisponibilities = (): ThunkAction<void, RootState, unknown, AnyAction> => {
//   return async(dispatch, getState) => {
//     dispatch(getDisponibilities());
//   }
// }
